<template>
  <div class="word_box" :id="content.key">
    <audio src="" id="audio_word"></audio>
    <span 
      class="word_title"
      :style="{
        marginTop: content.textStyle.marginTop + 'rem' || '',
      }"
      >{{ content.text }}</span
    >
    <div v-for="item in content.content" :key="item.key">
      <div
      class="word_list"
      v-for="items in item.content"
      :key="items.key"
    > 
    <div class="word_list_left">
        <div class="word_list_left_top">
          <span :style="{
            fontFamily: items.textStyle.fontFamily || '',
            fontSize: items.textStyle.fontSize + 'rem' || '',
            lineHeight: items.textStyle.lineHeight + 'rem' || '',
            fontWeight: items.textStyle.fontWeight || '',
            textDecoration:
              items.textStyle.underline === 1 ? 'underline' : '',
            fontStyle: items.textStyle.fontItalic === 1 ? 'italic' : '',
            textAlign: items.textStyle,
            color:items.ispop ?'#0482EC': items.textStyle.color,
          }">
          <!-- {{ items }} -->
            {{ items.ispop ?'':items.text }}<popover v-if="items.ispop" :content="items"></popover>
          </span>
          <span
            :style="{
              fontFamily: item.word_mark_style.fontFamily || '',
              fontSize: item.word_mark_style.fontSize + 'rem' || '',
              lineHeight: item.word_mark_style.lineHeight + 'rem' || '',
              fontWeight: item.word_mark_style.fontWeight || '',
              textDecoration:
                item.word_mark_style.underline === 1 ? 'underline' : '',
              fontStyle: item.word_mark_style.fontItalic === 1 ? 'italic' : '',
              textAlign: item.word_mark_style.textAlign || '',
              color: item.word_mark_style.color || '',
              backgroundColor: item.word_mark_style.backgroundColor || '',
            }"
            >{{ item.word_mark }}</span
          > 
        </div>
        <div class="word_list_left_bottom">
          <span
            v-for="ite in item.word_translate"
            :key="ite.key"
            ref=""
            :style="{
              color:ite.textStyle.color ||'',
              fontFamily: ite.textStyle.fontFamily || '',
              fontSize: ite.textStyle.fontSize + 'rem' || '',
              lineHeight: ite.textStyle.lineHeight + 'rem' || '',
              fontWeight: ite.textStyle.fontWeight || '',
              textDecoration:
                ite.textStyle.underline === 1 ? 'underline' : '',
              fontStyle: ite.textStyle.fontItalic === 1 ? 'italic' : '',
            }"
            >{{ ite.text }}</span
          >
        </div>
      </div>
      <div class="word_list_right">
        <img
          :src="
            !item.isPlay
              ? require('@/assets/images/books/book2/play_default.png')
              : require('@/assets/images/books/book2/play_process.png')
          "
          alt=""
          @click="audioPlayClick(item)"
        />
      </div>
    </div>
    </div>
  </div>
</template>
   
<script>
import popover from "../text/popover.vue";
export default {
  data() {
    return {
      isPlay: false,
    };
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: { popover },
  created() {},
  methods: {
    //音频播放点击
    audioPlayClick(item) {
      // 检查是否有其他audio或video正在播放
      // 获取所有的audio和video元素
      // const audios = document.querySelectorAll("audio");
      // const videos = document.querySelectorAll("video");
      // const isPlaying =
      //   audios.some((audio) => !audio.paused) ||
      //   videos.some((v) => v !== video && !v.paused);
      // if (isPlaying) {
      //   this.stopAllMedia(audios, videos); // 停止所有正在播放的媒体
      // }
      // if (this.isPlay) {
      //   return;
      // }
      for(let i = 0;i<this.content.content.length;i++){
        this.content.content[i].isPlay = false;
      }
      item.isPlay = !item.isPlay;
      if (item.isPlay) {
        var audio = document.getElementById("audio_word");
        audio.src = item.word_url;
        audio.play();
      } else {
        var audio = document.getElementById("audio_word");
        audio.pause();
      }
      audio.addEventListener("ended", function () {
        console.log("音频播放完成");
        item.isPlay = false;
      });
    },
    stopAllMedia(audios, videos) {
      // 添加参数
      audios.forEach((audio) => audio.pause());
      videos.forEach((video) => video.pause());
    },
  },
};
</script>
   
<style scoped lang='scss'>
.word_list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 662rem;
  min-height: 110rem;
  background: #eaf4f0;
  margin: 0 auto 10rem;
  padding: 22rem 35rem 22rem 30rem;
  box-sizing: border-box;
}
.word_title {
  background: #8cb894;
  height: 38rem;
  color: #fff;
  padding: 0 33rem;
  border-radius: 10rem 10rem 0 0;
  display: inline-block;
  margin: 0 auto;
  font-size: 24rem;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.word_list_left {
  flex: 1;
}
.word_list_left_top {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  span:nth-child(1) {
    min-width: 50%;
  }
}
.word_list_right img {
  width: 48rem;
  height: 48rem;
  cursor: pointer;
}
.word_list_left_bottom {
  margin-top: 20rem;
}
</style>